import type { EditorPointer } from '@wix/editorx-core-api';
import { CompRef } from '@wix/document-services-types';
import {
  EditActionsDictionary,
  NativeActionsList,
} from '@wix/editor-platform-host-integration-apis';

import { ManifestServicesAPI } from '../types';
import { hasData, isActionName } from '../utils';

type EditActionValidator = (
  manifestServicesAPI: ManifestServicesAPI,
  editorPointer: EditorPointer<CompRef>,
) => boolean;

export const editActionsValidators: EditActionsDictionary<EditActionValidator> =
  {
    [NativeActionsList.presets]: (manifestServicesAPI, editorPointer) =>
      !!manifestServicesAPI.get.presets(editorPointer)?.length,

    // [NativeActionsList.stretch]: (manifestServicesAPI, editorPointer) =>
    //   manifestServicesAPI.behaviors.getValueFromManifest(
    //     editorPointer,
    //     'stretch',
    //   ) !== 'NONE',
  };

export const deriveDefaultEditActionsFromManifest = (
  manifestServicesAPI: ManifestServicesAPI,
  editorPointer: EditorPointer<CompRef>,
) => {
  return Object.entries(editActionsValidators)
    .filter(
      ([actionKey, callback]) =>
        isActionName(actionKey) && callback(manifestServicesAPI, editorPointer),
    )
    .reduce(
      (acc, [actionName]) => ({
        ...acc,
        [actionName]: { actionName, hidden: false },
      }),
      {},
    );
};
